import { DocumentsState } from '../../interfaces/DocumentsState';
import { filterDocuments } from './filterDocuments';

export const resetDocuments = (state: DocumentsState): DocumentsState => filterDocuments({
  ...state,
  searchCriteria: {
    keyword: '',
    period: 'SELECT_ALL',
    type: [],
    product: [],
  },
});
